import styled from "styled-components";

import { WidgetFrame } from "components/layout/WidgetFrame";
import { Alert } from "components/ui/Alert";
import { Statistic } from "components/ui/Statistic";
import { useGetHorizonVersionAggregationQuery } from "store/services/liobs.service";
import { roundNumber } from "utils/number.utils";

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 1rem;
    margin-top: 1rem;

    @container page (max-width: ${({ theme }) => theme.breakpoints.xs}) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const OutdatedHorizonVersionFarmsWidget = () => {
    const dataSource = useGetHorizonVersionAggregationQuery();

    const { data, isLoading, isError, isFetching } = dataSource;

    return (
        <>
            <WidgetFrame.Title title="Farms with Outdated Horizon Version" icon={"lely-icon-version"} size={"sm"}>
                <WidgetFrame.Title.Information pageId={1924759597} />
            </WidgetFrame.Title>
            <WidgetFrame.Content>
                <WidgetFrame.DataContent dependencies={[{ isLoading, isError, isFetching }]}>
                    <Alert severity="info">
                        If you have access to multiple Lely Centers, this widget combines data from all of them. The
                        Lely Center picker does not affect the results.
                    </Alert>
                    <Wrapper>
                        <Statistic>
                            <Statistic.Label>Current Horizon SW Version</Statistic.Label>
                            <Statistic.Value>{data?.latestHorizonVersion}</Statistic.Value>
                        </Statistic>
                        <Statistic>
                            <Statistic.Label>Farms with Outdated Version</Statistic.Label>
                            <Statistic.Value>{data?.totalFarmCount}</Statistic.Value>
                        </Statistic>
                        <Statistic>
                            <Statistic.Label>Percentage of All Farms</Statistic.Label>
                            <Statistic.Value weight="bold">
                                {data ? roundNumber(data.outdatedHorizonVersionFarmPercentage * 100, 2) : "-"}%
                            </Statistic.Value>
                        </Statistic>
                    </Wrapper>
                </WidgetFrame.DataContent>
            </WidgetFrame.Content>
        </>
    );
};
